import { Injectable, effect, inject } from '@angular/core';
import { FikoYTRequestService } from '@/src/app/shared/services/fikoyt-request.service';
import { DinamikBilesenRegistry } from './dinamik-bilesen.registry';
import { CanliGuncellemeService } from './canli-guncelleme.service';

const DB = 'FikoYT.sistem.DB.hareketler.aggregate';
const TTL = 30_000;

@Injectable({ providedIn: 'root' })
export class AltKartHesaplamaService {
  private req = inject(FikoYTRequestService);
  private cache = new Map<string, { veri: Record<string, any>; zaman: number }>();

  constructor() {
    // Kart değişince hesap cache'ini geçersiz kıl (bayat veri önleme)
    const canli = inject(CanliGuncellemeService);
    effect(() => {
      const g = canli.kartGuncellendi();
      if (g?.kartId) this.cacheSifirla(g.kartId);
    });
    effect(() => {
      const id = canli.kartSilindi();
      if (id) this.cacheSifirla(id);
    });
    effect(() => {
      const olay = canli.sunucuOlayi();
      if (olay?.kartId) this.cacheSifirla(olay.kartId);
    });
  }

  async hesapla(kartId: string, bilesenId: string): Promise<Record<string, any>> {
    const cacheKey = `${kartId}_${bilesenId}`;
    const cached = this.cache.get(cacheKey);
    if (cached && Date.now() - cached.zaman < TTL) return cached.veri;

    const tanim = await DinamikBilesenRegistry.yukle(bilesenId);
    const hesaplamalar = (tanim as any)?.hesaplamalar;
    if (!hesaplamalar?.pipeline?.length) return {};

    const pipeline = JSON.parse(
      JSON.stringify(hesaplamalar.pipeline).replace(/\{\{kartId\}\}/g, kartId)
    );

    try {
      const sonuc = await this.req.aggregate(DB, pipeline);
      const veri = this.sonucuIsle(sonuc);
      this.cache.set(cacheKey, { veri, zaman: Date.now() });
      return veri;
    } catch (e) {
      console.warn('[AltKartHesaplama] Aggregate hatası:', bilesenId, e);
      return {};
    }
  }

  private sonucuIsle(sonuc: any[]): Record<string, any> {
    if (!sonuc?.length) return {};
    const result: Record<string, any> = {};
    for (const item of sonuc) {
      if (item._id != null) {
        result[item._id] = item;
      } else {
        Object.assign(result, item);
      }
    }
    return result;
  }

  cacheSifirla(kartId?: string) {
    if (kartId) {
      for (const key of this.cache.keys()) {
        if (key.startsWith(kartId + '_')) this.cache.delete(key);
      }
    } else {
      this.cache.clear();
    }
  }
}
